import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay } from 'swiper';
import { formatImageWebpAuto } from '@ifeng/public_method';
import { PlayUrl } from '@src/constants';
import { gotoNewPage } from '@src/utils';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const Layout = ({ content }) => {
    let { slideData = [] } = content;

    slideData = [...slideData].splice(0, 12);
    const [title, setTitle] = useState(slideData[0]?.title || '');
    const playVideo = (index) => {
        return gotoNewPage({ url: `${PlayUrl}?index=${index}`, type: 'web' });
    };

    return (
        <div className={styles.layout}>
            <div className={styles.header} />
            <div className={styles.container}>
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={1}
                    initialSlide={0}
                    loop={true}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 20,
                        depth: 20,
                        modifier: 6,
                        slideShadows: false,
                    }}
                    modules={[EffectCoverflow, Autoplay]}
                    loopAdditionalSlides={2}
                    key="swiper"
                    autoplay
                    className={styles.swiper}
                    speed={1500}
                    onSlideChange={(swiper) => {
                        setTitle(slideData[swiper.realIndex].title);
                    }}>
                    {slideData.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className={styles.swiperItem}>
                                    <img src={formatImageWebpAuto(item.backgroundImage, 445, 592)} alt="" />
                                    <div className={styles.playBtn} onClick={playVideo(index)} />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <div className={styles.title}>{title}</div>
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
